/**
 * WangYuan — Premium Scroll Animations
 * AG1-inspired editorial motion: subtle fade-up, staggered children,
 * viewport-triggered only, never bouncy, always ease-out.
 */

(function () {
  'use strict';

  // ── Skip if user prefers reduced motion ───────────────────────────────────
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  // ── Base CSS ──────────────────────────────────────────────────────────────
  const style = document.createElement('style');
  style.textContent = `
    .anim-fade-up,
    .anim-fade-left,
    .anim-fade-right,
    .anim-scale-in {
      opacity: 0;
      will-change: transform, opacity;
    }
    .anim-fade-up    { transform: translateY(28px); }
    .anim-fade-left  { transform: translateX(-24px); }
    .anim-fade-right { transform: translateX(24px); }
    .anim-scale-in   { transform: scale(0.97); }

    .anim-fade-up.is-visible,
    .anim-fade-left.is-visible,
    .anim-fade-right.is-visible,
    .anim-scale-in.is-visible {
      opacity: 1;
      transform: none;
      transition-property: opacity, transform;
      transition-duration: 0.8s;
      transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
    }
  `;
  document.head.appendChild(style);

  // ── Selectors to NEVER animate (nav, header) ─────────────────────────────
  const EXCLUDED = [
    'header',
    '.header',
    '#header',
    'header-component',
    '.header-section',
    'nav',
    '.announcement-bar',
    '#announcement-bar',
    '#header-group',
    '.shopify-section-group-header-group',
  ];

  function isExcluded(el) {
    return EXCLUDED.some(sel => {
      try { return el.closest(sel) !== null; } catch { return false; }
    });
  }

  // ── Observer ──────────────────────────────────────────────────────────────
  let observer;

  function createObserver() {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          const delay = parseInt(el.dataset.delay || '0', 10);

          requestAnimationFrame(() => {
            setTimeout(() => {
              el.classList.add('is-visible');
              observer.unobserve(el); // trigger once only
            }, delay);
          });
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -48px 0px',
      }
    );
  }

  // ── Watch elements ────────────────────────────────────────────────────────
  function watchElements() {
    const animClasses = ['.anim-fade-up', '.anim-fade-left', '.anim-fade-right', '.anim-scale-in'];
    const selector = animClasses.join(', ');
    const elements = document.querySelectorAll(selector);

    elements.forEach(el => {
      if (isExcluded(el)) return;
      if (el.classList.contains('is-visible')) return; // already animated
      observer.observe(el);
    });
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  function initAnimations() {
    if (!observer) createObserver();
    watchElements();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }

  // Re-run after Shopify theme editor section re-renders
  document.addEventListener('shopify:section:load', initAnimations);
  document.addEventListener('shopify:block:select', initAnimations);

  // Expose globally for debugging / manual re-init
  window.WY = window.WY || {};
  window.WY.initAnimations = initAnimations;
})();
